import { useLayoutEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MainContainer from "../../components/container/MainContainer";
import PageTitle from "../../components/titles/PageTitle";
import Loading from "../../components/loading/Loading";
import TextContainer from "../../components/text/TextContainer";
import Modal from "../../components/modal/Modal";
import { openModal } from "../../features/modalSLice";
import { useAuthorization } from "../../hooks/useAuthorization";
import { getDepartment } from "../../features/departmentSlice";
import AddDepartment from "./AddDepartment";
import DeleteDepartment from "./DeleteDepartment";
import loadStatus from "../../util/loadStatus";
import NetworkError from "../error/NetworkError";

const SingleDepartment = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const { isAuthorized } = useAuthorization();
  const modalContent = useSelector((state) => state.modal.content);
  const department = useSelector((state) => state.departments.selected);
  const loading = useSelector((state) => state.departments.load.getDepartment);

  const openEditDepartmentModal = (edit, id) => {
    dispatch(openModal(<AddDepartment edit={edit} id={id} />));
  };

  const openDeleteDepartmentModal = (id) => {
    dispatch(openModal(<DeleteDepartment id={id} />));
  };

  useLayoutEffect(() => {
    dispatch(getDepartment(id));
  }, []);

  if (loading === loadStatus.loading) {
    return <Loading />;
  }

  if (loading === loadStatus.error) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <MainContainer>
      <Modal>{modalContent}</Modal>
      <PageTitle title={"Department - " + department.name} />
      <div className="bg-content  border border-bkg2 rounded-md p-7 mb-5 !text-text-1/55">
        <TextContainer label="Name" content={department.name} />
        <TextContainer label="Slug" content={department.slug} />
        <TextContainer label="Province" content={department.province} />
      </div>
      <div className="p-4 border border-bkg2 rounded-md ">
        <div className="flex gap-3">
          <button
            onClick={(e) => openEditDepartmentModal(true, id)}
            disabled={!isAuthorized("departments", "update")}
            className="add-rss-btn"
          >
            Edit
          </button>
          <button
            onClick={(e) => openDeleteDepartmentModal(id)}
            disabled={!isAuthorized("departments", "delete")}
            className="delete-rss-btn"
          >
            Delete
          </button>
        </div>
      </div>
    </MainContainer>
  );
};

export default SingleDepartment;
